import styled from 'styled-components'

import { CreatableSelect } from '../../../components/FormElements'
import { Button } from '../../../components/Buttons'
import Icon from '../../../components/Icon'
import sizes from '../../../styles/media'

export const AddFeatureWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 186px;
  height: 100%;
  flex-direction: column;
  color: #858585;
`

export const AddFeatureText = styled.span`
  margin-top: 15px;
`

export const SaveButton = styled(Button)`
  width: 100%;
  @media ${sizes.sm} {
    width: auto;
  }
`

export const CloseButton = styled.button`
  font-size: 14px;
  position: absolute;
  top: -14px;
  right: -24px;
  cursor: pointer;
  color: #fff;
  background: none;
  border: none;
  display: block;
  z-index: 1;
`

export const CloseIcon = styled(Icon)`
  font-size: 34px;
  color: #ff2d2d;
`
export const ExistOptionsContainer = styled.div`
  display: flex;
  align-items: left;
  justify-content: left;
  padding-bottom: 15px;
`
export const ExistOptions = styled.p`
  color: #858585;
`

const className = 'old-elements'

interface Props {
  type?: string
  color?: string
}
export const OldElements = styled(CreatableSelect).attrs<Props>({
  className,
})`
  ${'div'} {
    background-color: transparent;
    border: none;
    div {
      padding: 0.2rem 0.5rem;
      :last-child {
        display: none;
      }
    }
    div > div {
      background-color: #858585;
      div {
        :nth-child(even) {
          display: none;
        }
      }
    }
  }
`
